import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import WorkerHeader from '../../worker-header/components/index';
import WorkerFooter from "../../worker-footer/components/index";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addProvider, addWorkerApplicant, addPartner } from "../slice/workerRegisterSlice";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReCAPTCHA from "react-google-recaptcha";
const BACKEND_URL = process.env.REACT_APP_NODE_API;

const WorkerBotChat = () => {

    const navigate = useNavigate();

    const [sessionId, setSessionId] = useState(null);
    const [message, setMessage] = useState("");
    const [step, setStep] = useState(1);
    const [type, setType] = useState("text");
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [completedData, setCompletedData] = useState(null);
    const [currentKey, setCurrentKey] = useState("");
    const [checkboxValues, setCheckboxValues] = useState([]);
    const [activeMultiField, setActiveMultiField] = useState(null);
    const [multiInputData, setMultiInputData] = useState({
        firstName: "",
        lastName: ""
    });
    const [dynamicMultiInput, setDynamicMultiInput] = useState({});
    const [passwordData, setPasswordData] = useState({
        password: "",
        confirmPassword: ""
    });
    const [chatHistory, setChatHistory] = useState([]);
    const chatContainerRef = useRef(null);
    const [title, setTitle] = useState("");
    const [totalSteps, setTotalSteps] = useState(0);
    // const [verificationFile, setVerificationFile] = useState(null);
    const [files, setFiles] = useState({});
    const [loading, setLoading] = useState(false);
    // Mic / Speech Recognition
    const [listening, setListening] = useState(false);
    const recognitionRef = useRef(null);
    const [reviewData, setReviewData] = useState(null);
    const [facilityData, setFacilityData] = useState(null);
    const [staffProvidersData, setStaffProvidersData] = useState([]);
    const modalRef = useRef(null);
    const FacilityModalRef = useRef(null);
    const StaffProvidersModalRef = useRef(null);
    const [onboardingStatus, setOnboardingStatus] = useState(null);
    const [selectedFacilities, setSelectedFacilities] = useState([]);
    const [selectedStaffProvider, setSelectedStaffProvider] = useState(null);
    const dispatch = useDispatch();
    const REVIEW_KEYS = [
        "reviewAction",
        "staffReviewAction",
        "providerReviewAction",
        "partnerReviewAction"
    ];
    const isReviewStep = REVIEW_KEYS.includes(currentKey);
    const [captchaText, setCaptchaText] = useState("");
    const [captchaInput, setCaptchaInput] = useState("");
    const [captchaValue, setCaptchaValue] = useState(null);
    const [showCaptchaModal, setShowCaptchaModal] = useState(false);

    const recaptchaRef = useRef(null);

    useEffect(() => {
        if (reviewData && modalRef.current) {
            const modal = new window.bootstrap.Modal(modalRef.current);
            modal.show();
        }
    }, [reviewData]);

    useEffect(() => {
        if (facilityData && FacilityModalRef.current) {
            const modal = new window.bootstrap.Modal(FacilityModalRef.current);
            modal.show();
        }
    }, [facilityData]);

    useEffect(() => {
        if (
            staffProvidersData &&
            staffProvidersData.length > 0 &&
            StaffProvidersModalRef.current
        ) {
            const modal = new window.bootstrap.Modal(StaffProvidersModalRef.current);
            modal.show();
        }
    }, [staffProvidersData]);

    useEffect(() => {
        startBot();
    }, []);
    // Scroll to bottom
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }

        // Speak last bot message
        const lastMessage = chatHistory[chatHistory.length - 1];
        if (lastMessage && lastMessage.sender === "bot") {
            speak(lastMessage.text);
        }
    }, [chatHistory]);

    // Speak function
    const speak = (text) => {
        if (!('speechSynthesis' in window) || !text) return;

        const synth = window.speechSynthesis;

        const speakNow = () => {
            const voices = synth.getVoices();
            // console.log("voices", voices);

            const femaleVoice = voices.find(voice =>
                voice.lang === "en-US" && /female|Google/i.test(voice.name)
            );

            // console.log("female voice", femaleVoice);

            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = "en-US";
            utterance.rate = 1;
            utterance.pitch = 1;

            if (femaleVoice) {
                utterance.voice = femaleVoice;
            }

            synth.cancel();
            synth.speak(utterance);
        };

        // ✅ If voices already loaded
        if (synth.getVoices().length > 0) {
            speakNow();
        } else {
            // ⏳ Wait for voices
            synth.onvoiceschanged = () => {
                speakNow();
            };
        }
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    const generateCaptcha = () => {

        const chars =
            "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789";

        let result = "";

        for (let i = 0; i < 6; i++) {
            result += chars.charAt(
                Math.floor(Math.random() * chars.length)
            );
        }

        setCaptchaText(result);
    };

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const verifyCaptchaAndSubmit = async () => {

        // if (captchaInput !== captchaText) {
        //     alert("Captcha incorrect");
        //     generateCaptcha();
        //     setCaptchaInput("");
        //     return;
        // }

        // setShowCaptchaModal(false);

        // handleSubmit("confirm");

        if (!captchaValue) {
            alert("Please complete CAPTCHA");
            return;
        }

        try {

            // Verify from backend
            const response = await fetch(`${BACKEND_URL}/verify-captcha`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    captcha: captchaValue,
                }),
            });

            const data = await response.json();
            // Success
            if (data.success) {

                setShowCaptchaModal(false);

                handleSubmit("confirm");

            } else {

                alert("Captcha verification failed");

                // Reset captcha
                recaptchaRef.current.reset();

                setCaptchaValue(null);
            }

        } catch (error) {

            console.error(error);

            alert("Something went wrong");

            recaptchaRef.current.reset();

            setCaptchaValue(null);
        }
    };

    const formatToMMDDYYYY = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const year = d.getFullYear();
        return `${month}/${day}/${year}`;
    };
    // Start session
    const startBot = async () => {
        const res = await axios.post(`${BACKEND_URL}/bot/bot-start`);

        setSessionId(res.data.sessionId);
        setMessage(res.data.message);
        setType(res.data.type);
        setOptions(res.data.options || []);
        setCurrentKey(res.data.key);
        setTitle(res.data.title);
        setTotalSteps(res.data.totalSteps);

        setChatHistory([{ sender: "bot", text: res.data.message }]);
    };

    // Start speech recognition
    const startListening = () => {
        if (!('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)) {
            alert("Speech Recognition not supported in this browser.");
            return;
        }

        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = new SpeechRecognition();
        recognition.lang = 'en-US';
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript.trim();
            // console.log("Transcript:", transcript);

            // Handle multi-inputs
            if (currentKey === "fullName") {
                const parts = transcript.split(" ");
                setMultiInputData({
                    firstName: parts[0] || "",
                    lastName: parts[1] || ""
                });
                handleSubmit(); // auto-submit after filling both fields
            }
            else if (type === "double_password") {
                // For passwords, we probably just fill the first password field
                setPasswordData(prev => ({ ...prev, password: transcript }));
                // Do NOT auto-submit until user confirms
            }
            else if (type === "multi_input" && activeMultiField) {
                setDynamicMultiInput(prev => ({
                    ...prev,
                    [activeMultiField]: transcript
                }));
            }
            else {
                // Single text input
                if (type === "text") {
                    setInputValue(transcript);
                } else {
                    setInputValue(transcript);
                    handleSubmit(transcript);
                }
            }

            setListening(false);
        };

        recognition.onend = () => setListening(false);

        recognition.start();
        setListening(true);
        recognitionRef.current = recognition;
    };


    const providerRegisterAPI = async (data) => {
        try {
            setLoading(true);
            console.log("Provider registration data:", data);

            // Base Payload (Common Fields)
            const basePayload = {
                role: data.role,
                operation_status: data.operationStatus,
                states: data.state,
                role_id: 3, // move to constant later
                user_type: 3,
                first_name: data.first_name || data.firstName || "",
                last_name: data.last_name || data.lastName || "",
                email: data.email,
                phone: data.phone,
                password: data.password,
                c_password: data.confirmPassword,
                business_name: data.legalBusinessName,
                ein: data.ein,
                license_facility_id: data.license_facility_id,
                service_type: data.serviceType,
                message: data.message,
                additionalFacilities: JSON.stringify(data.additionalFacilities)
            };

            let finalPayload = { ...basePayload };

            // Conditional Fields
            if (data.operationStatus === "operating") {
                finalPayload = {
                    ...finalPayload,
                    provider_sub_role: data.providerSubRole,
                    improvement_choice: data.improvementChoice,
                    staff_count: data.workforceSize,
                    facility_type: data.programTypeOperating,
                };
            }

            if (data.operationStatus === "planning") {
                finalPayload = {
                    ...finalPayload,
                    licensed: data.licensed,
                    hiring90: data.hiring90,
                    facility_type: data.programTypePlanning,
                };
            }

            const result = await dispatch(addProvider(finalPayload));

            if (result.meta.requestStatus === "fulfilled") {

                const modal = window.bootstrap.Modal.getInstance(modalRef.current);
                if (modal) modal.hide();

                setChatHistory([]);
                setReviewData(null);
                setCompletedData(null);

                setLoading(false);
                setOnboardingStatus("success");

                toast.success("Provider registered successfully", {
                    position: "top-right",
                    autoClose: 2000,
                    style: { fontSize: "0.85rem" },
                });

                await axios.post(`${BACKEND_URL}/bot/bot-session-delete`, {
                    sessionId
                });

            } else {

                const modal = window.bootstrap.Modal.getInstance(modalRef.current);
                if (modal) modal.hide();

                setLoading(false);

                const errorMessage =
                    result.payload?.data ||
                    result.payload?.message ||
                    "Something went wrong";

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    style: { fontSize: "0.85rem" },
                });

                const error_type = result.payload?.error_name;

                await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                    sessionId,
                    stepData: { providerReviewAction: "change" },
                });

                const res = await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                    sessionId,
                    stepData: { providerChangeField: error_type },
                });



                setMessage(res.data.message);
                // setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
                setChatHistory(prev => prev.filter(msg => !msg.loading));

                if (res.data.message) {
                    setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
                }
                setTitle(res.data.title);
                setTotalSteps(res.data.totalSteps);
                setStep(res.data.step);
                setType(res.data.type);
                setOptions(res.data.options || []);
                setCurrentKey(res.data.key);
                setInputValue("");
            }


            // navigate("/panel/my-job");

        } catch (error) {
            console.error(error);
            toast.error("Failed to register provider.");
        }
    };

    const workerRegisterAPI = async (data) => {
        // console.log("data", data);

        if (data.workerStatus === "applicant") {
            setLoading(true);

            const applicantPayload = {
                provider_code_name: data.providerCode,
                state_of_work: data.stateOfWork,
                role_seeking: data.roleSeeking,
                required_clearances: data.clearanceStatus,
                name: `${data.firstName} ${data.lastName}`,
                email: data.email,
            };

            let finalPayload = { ...applicantPayload };

            // console.log("finalPayload", finalPayload);
            // return;
            const result = await dispatch(addWorkerApplicant(finalPayload));
            if (result.meta.requestStatus === "fulfilled") {

                setChatHistory([]);
                setReviewData(null);
                setCompletedData(null);

                setLoading(false);
                setOnboardingStatus("success");

                const modal = window.bootstrap.Modal.getInstance(modalRef.current);
                if (modal) modal.hide();

                toast.success("Worker Applicant successfully", {
                    position: "top-right",
                    autoClose: 2000,
                    style: { fontSize: "0.85rem" },
                });

                await axios.post(`${BACKEND_URL}/bot/bot-session-delete`, {
                    sessionId
                });

            } else {

                const modal = window.bootstrap.Modal.getInstance(modalRef.current);
                if (modal) modal.hide();

                setLoading(false);

                const errorMessage =
                    result.payload?.data ||
                    result.payload?.message ||
                    "Something went wrong";

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 2000,
                    style: { fontSize: "0.85rem" },
                });

                const error_type = result.payload?.error_name;

                await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                    sessionId,
                    stepData: { reviewAction: "change" },
                });

                const res = await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                    sessionId,
                    stepData: { changeField: error_type },
                });


                // setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
                setChatHistory(prev => prev.filter(msg => !msg.loading));

                if (res.data.message) {
                    setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
                }
                setTitle(res.data.title);
                setTotalSteps(res.data.totalSteps);
                setStep(res.data.step);
                setType(res.data.type);
                setOptions(res.data.options || []);
                setCurrentKey(res.data.key);
                setInputValue("");
            }

        } else if (data.workerStatus === "staff") {
            console.log("data", data);
            setLoading(true);

            const formData = new FormData();

            const staffRole = data.staffRoleType;

            let roleId = 5; // default staff

            if (
                staffRole === "Director" ||
                staffRole === "Lead Teacher" ||
                staffRole === "Assistant" ||
                staffRole === "Substitute"
            ) {
                roleId = 5;
            } else if (staffRole === "Support") {
                roleId = 6;
            }

            formData.append("role", data.role);
            formData.append("referral_code", data.referral_code);
            formData.append("states", data.staffState);
            formData.append("worker_type", data.staffRoleType);
            formData.append("first_name", data.firstName);
            formData.append("last_name", data.lastName);
            formData.append("email", data.email);
            formData.append("date_of_birth", data.dob);
            formData.append("phone", data.phone);
            formData.append("password", data.password);
            formData.append("c_password", data.confirmPassword);
            formData.append("role_id", roleId);
            formData.append("employment_type", data.employmentType);
            // formData.append("referencePermission", data.referencePermission);
            // formData.append("employment_history", data.employmentHistory);
            formData.append(
                "benefit_enrollment_preferences",
                Array.isArray(data.benefits) ? data.benefits.join(",") : ""
            );
            formData.append(
                "digital_signature_of_acknowledgment",
                data.digitalSignature
            );

            // 🔥 THIS IS IMPORTANT
            // if (verificationFile) {
            //     formData.append("upload_verification_docs", verificationFile);
            // }

            if (files.employmentHistory) {
                formData.append("employment_history", files.employmentHistory);
            }

            if (files.uploadVerification) {
                formData.append("upload_verification_docs", files.uploadVerification);
            }
            const result = await dispatch(addProvider(formData));
            if (result.meta.requestStatus === "fulfilled") {

                const modal = window.bootstrap.Modal.getInstance(modalRef.current);
                if (modal) modal.hide();

                setChatHistory([]);
                setReviewData(null);
                setCompletedData(null);

                setLoading(false);
                setOnboardingStatus("success");

                toast.success("Worker Applicant successfully", {
                    position: "top-right",
                    autoClose: 2000,
                    style: { fontSize: "0.85rem" },
                });

                await axios.post(`${BACKEND_URL}/bot/bot-session-delete`, {
                    sessionId
                });

            } else {
                const modal = window.bootstrap.Modal.getInstance(modalRef.current);
                if (modal) modal.hide();


                setLoading(false);

                const errorMessage =
                    result.payload?.data ||
                    result.payload?.message ||
                    "Something went wrong";

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 2000,
                    style: { fontSize: "0.85rem" },
                });

                const error_type = result.payload?.error_name;

                await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                    sessionId,
                    stepData: { staffReviewAction: "change" },
                });

                const res = await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                    sessionId,
                    stepData: { staffChangeField: error_type },
                });

                setChatHistory(prev => prev.filter(msg => !msg.loading));

                if (res.data.message) {
                    setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
                }
                setTitle(res.data.title);
                setTotalSteps(res.data.totalSteps);
                setStep(res.data.step);
                setType(res.data.type);
                setOptions(res.data.options || []);
                setCurrentKey(res.data.key);
                setInputValue("");
            }
        }
        return;
    };

    const partnerRegisterAPI = async (data) => {
        try {
            setLoading(true);

            let finalPayload = {
                partner_role: data.partnerType,
                email: data.email,
                partner_budget: data.partnerBudget,
            };

            if (data.partnerType === "funder") {
                finalPayload = { ...finalPayload, interest: data.funderInterest, name: data.fullName };
            } else if (data.partnerType === "sponsor") {
                finalPayload = { ...finalPayload, name: data.organization, sponsor_type: data.sponsorType };
            } else if (data.partnerType === "agency") {
                finalPayload = { ...finalPayload, name: data.agencyName, agency_level: data.agencyLevel };
            } else {
                toast.error("Invalid partner type.");
                return;
            }

            // ✅ unwrap throws if rejected
            const result = await dispatch(addPartner(finalPayload)).unwrap();

            // ✅ If we reach here, it succeeded
            setChatHistory([]);
            setReviewData(null);
            setCompletedData(null);

            setLoading(false);
            setOnboardingStatus("success");

            const modal = window.bootstrap.Modal.getInstance(modalRef.current);
            if (modal) modal.hide();

            toast.success(result.message || "Partner registered", {
                position: "top-right",
                autoClose: 2000,
                style: { fontSize: "0.85rem" },
            });

            await axios.post(`${BACKEND_URL}/bot/bot-session-delete`, { sessionId });

        } catch (error) {
            // ✅ unwrap throws rejected payload here
            console.error("Partner registration failed:", error);

            const modal = window.bootstrap.Modal.getInstance(modalRef.current);
            if (modal) modal.hide();

            // setChatHistory([]);
            // setReviewData(null);
            // setCompletedData(null);

            setLoading(false);
            // setOnboardingStatus("failed");

            const errorMessage = error?.data || error?.message || "Partner registration failed.";

            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 2000,
                style: { fontSize: "0.85rem" },
            });

            // Send user back to review step
            const res = await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                sessionId,
                stepData: { partnerReviewAction: "change" },
            });

            setChatHistory(prev => prev.filter(msg => !msg.loading));

            if (res.data.message) {
                setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
            }
            setTitle(res.data.title);
            setTotalSteps(res.data.totalSteps);
            setStep(res.data.step);
            setType(res.data.type);
            setOptions(res.data.options || []);
            setCurrentKey(res.data.key);
            setInputValue("");
        } finally {
            setLoading(false);
        }
    };

    const volunteerRegisterAPI = async (data) => {
        // console.log("volunteerRegisterAPI called", data);
        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("role_id", 7);
            formData.append("first_name", data.first_name || data.firstName);
            formData.append("last_name", data.last_name || data.lastName);
            formData.append("email", data.email);
            formData.append("phone", data.phone);
            formData.append("password", data.password);
            formData.append("c_password", data.confirmPassword);

            // Append volunteer categories correctly
            (data.VolunteerCategories || []).forEach(category => {
                formData.append("volunteer_category[]", category);
            });

            const result = await dispatch(addProvider(formData));

            if (result.meta.requestStatus === "fulfilled") {

                const modal = window.bootstrap.Modal.getInstance(modalRef.current);
                if (modal) modal.hide();


                toast.success("Volunteer registered successfully", {
                    position: "top-right",
                    autoClose: 2000,
                    style: { fontSize: "0.85rem" },
                });

                await axios.post(`${BACKEND_URL}/bot/bot-session-delete`, {
                    sessionId
                });

                setChatHistory([]);
                setReviewData(null);
                setCompletedData(null);

                setLoading(false);
                setOnboardingStatus("success");


            } else {

                const modal = window.bootstrap.Modal.getInstance(modalRef.current);
                if (modal) modal.hide();

                setLoading(false);

                const errorMessage =
                    result.payload?.data ||
                    result.payload?.message ||
                    "Something went wrong";

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    style: { fontSize: "0.85rem" },
                });

                const error_type = result.payload?.error_name;

                await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                    sessionId,
                    stepData: { volunteerReviewAction: "change" },
                });

                const res = await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                    sessionId,
                    stepData: { volunteerChangeField: error_type },
                });



                setMessage(res.data.message);
                // setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
                setChatHistory(prev => prev.filter(msg => !msg.loading));

                if (res.data.message) {
                    setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
                }
                setTitle(res.data.title);
                setTotalSteps(res.data.totalSteps);
                setStep(res.data.step);
                setType(res.data.type);
                setOptions(res.data.options || []);
                setCurrentKey(res.data.key);
                setInputValue("");
            }
        } catch (error) {
            // ✅ unwrap throws rejected payload here
            console.error("Volunteer registration failed:", error);

            const modal = window.bootstrap.Modal.getInstance(modalRef.current);
            if (modal) modal.hide();

            // setChatHistory([]);
            // setReviewData(null);
            // setCompletedData(null);

            setLoading(false);
            // setOnboardingStatus("failed");

            const errorMessage = error?.data || error?.message || "Partner registration failed.";

            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 2000,
                style: { fontSize: "0.85rem" },
            });

            // Send user back to review step
            const res = await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                sessionId,
                stepData: { volunteerReviewAction: "change" },
            });

            setChatHistory(prev => prev.filter(msg => !msg.loading));

            if (res.data.message) {
                setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
            }
            setTitle(res.data.title);
            setTotalSteps(res.data.totalSteps);
            setStep(res.data.step);
            setType(res.data.type);
            setOptions(res.data.options || []);
            setCurrentKey(res.data.key);
            setInputValue("");
        } finally {
            setLoading(false);
        }
        return;
    }

    function splitFullName(fullName) {
        if (!fullName) return { first_name: "", last_name: "" };

        // Trim extra spaces
        const nameParts = fullName.trim().split(/\s+/);

        if (nameParts.length === 1) {
            return { first_name: nameParts[0], last_name: "" };
        }

        // Last word is last name
        const last_name = nameParts.pop();

        // Rest is first name (including title if present)
        const first_name = nameParts.join(" ");

        return { first_name, last_name };
    }

    function mapWorkforceSize(rawSize) {
        if (!rawSize) return "other";

        // Remove commas and split in case of multiple numbers
        const numbers = rawSize
            .split(',')
            .map(n => parseInt(n.trim()))
            .filter(n => !isNaN(n));

        if (numbers.length === 0) return "other";

        // Take the **max** number as representative
        const maxSize = Math.max(...numbers);

        if (maxSize <= 5) return "1_5";
        if (maxSize <= 15) return "6_15";
        if (maxSize <= 30) return "16_30";
        return "30_plus";
    }

    const cleanText = (text) => {
        if (!text) return "";
        return text.replace(/<[^>]*>/g, "") // remove HTML tags
            .replace(/\s+/g, " ")   // remove extra spaces, tabs, newlines
            .trim();
    };

    const getLicensedStatus = (html) => {
        if (!html) return "not_sure";

        const cleanText = html.replace(/<[^>]*>/g, "").trim().toLowerCase();

        if (cleanText.includes("exempt")) return "no";
        if (cleanText.includes("year")) return "yes";

        return "not_sure";
    };

    const handleFacilitySelect = (facility) => {
        setSelectedFacilities(prev => {
            const exists = prev.includes(facility);

            if (exists) {
                return prev.filter(f => f !== facility);
            } else {
                return [...prev, facility];
            }
        });
    };

    const handleMultipleClaim = async () => {
        try {
            if (selectedFacilities.length === 0) return;

            setChatHistory(prev => prev.slice(0, -1));

            let mainData = {};
            let additionalFacilities = {};

            selectedFacilities.forEach((facility, index) => {
                const { first_name, last_name } = splitFullName(facility.details.Administrator);

                const facilityTypeHtml = facility.details["Facility Type"];
                const licenseTypeHtml = facility.details["License Type"];

                const licensed = getLicensedStatus(licenseTypeHtml);
                const workforceSize = mapWorkforceSize(facility.details.Capacity);

                const getProgramTypeOperating = (html) => {
                    if (!html) return "other";

                    const cleanType = html.replace(/<[^>]*>/g, "").trim().toLowerCase();

                    if (cleanType.includes("child day center")) return "center";
                    if (cleanType.includes("religious exempt child day center")) return "faith_based";
                    if (cleanType.includes("family day home")) return "home_family";
                    if (cleanType.includes("family child care")) return "home_family";
                    if (cleanType.includes("multi")) return "multi_location";

                    return "other";
                };

                const programType = getProgramTypeOperating(facilityTypeHtml);

                const facilityData = {
                    first_name,
                    last_name,
                    phone: facility.phone,
                    state: facility.state || "VA",
                    workforceSize,
                    license_facility_id: facility.details["License/Facility ID#"],
                    programTypeOperating: programType,
                    programTypePlanning: programType,
                    licensed
                };

                // ✅ First record → main data
                if (index === 0) {
                    mainData = facilityData;
                }
                // ✅ बाकी → additionalFacilities object
                else {
                    const suffix = index; // 1, 2, 3...

                    additionalFacilities[`first_name${suffix}`] = first_name;
                    additionalFacilities[`last_name${suffix}`] = last_name;
                    additionalFacilities[`phone${suffix}`] = facility.phone;
                    additionalFacilities[`state${suffix}`] = facility.state || "VA";
                    additionalFacilities[`workforceSize${suffix}`] = workforceSize;
                    additionalFacilities[`license_facility_id${suffix}`] = facility.details["License/Facility ID#"];
                    additionalFacilities[`programTypeOperating${suffix}`] = programType;
                    additionalFacilities[`programTypePlanning${suffix}`] = programType;
                    additionalFacilities[`licensed${suffix}`] = licensed;
                }
            });

            // ✅ FINAL PAYLOAD
            const finalPayload = {
                ...mainData,
                additionalFacilities
            };

            // ✅ SINGLE API CALL
            await axios.post(`${BACKEND_URL}/bot/bot-session-update`, {
                sessionId,
                data: finalPayload,
                nextStep: 10
            });

            const primaryPhone = mainData.phone?.replace(/\D/g, "");

            const res = await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                sessionId,
                stepData: { phone: primaryPhone },
            });

            setMessage(res.data.message);
            setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
            setTitle(res.data.title);
            setTotalSteps(res.data.totalSteps);
            setStep(res.data.step);
            setType(res.data.type);
            setOptions(res.data.options || []);
            setCurrentKey(res.data.key);

            const modal = window.bootstrap.Modal.getInstance(FacilityModalRef.current);
            if (modal) modal.hide();

        } catch (err) {
            console.error(err);
            alert("Error processing multiple claims");
        }
    };

    const claimFacility = async (facility) => {

        setChatHistory(prev => prev.slice(0, -1));

        const { first_name, last_name } = splitFullName(facility.details.Administrator);

        const facilityTypeHtml = facility.details["Facility Type"];

        const licenseTypeHtml = facility.details["License Type"];
        const licensed = getLicensedStatus(licenseTypeHtml);

        const workforceSize = mapWorkforceSize(facility.details.Capacity);

        const getProgramTypeOperating = (html) => {
            if (!html) return "other";

            const cleanType = html.replace(/<[^>]*>/g, "").trim().toLowerCase();

            if (cleanType.includes("child day center")) return "center";
            if (cleanType.includes("religious exempt child day center")) return "faith_based";
            if (cleanType.includes("family day home")) return "home_family";
            if (cleanType.includes("family child care")) return "home_family";
            if (cleanType.includes("multi")) return "multi_location";

            return "other";
        };

        const programType = getProgramTypeOperating(facilityTypeHtml);

        await axios.post(`${BACKEND_URL}/bot/bot-session-update`, {
            sessionId,
            data: {
                first_name,
                last_name,
                phone: facility.phone,
                state: facility.state || "VA",
                workforceSize,
                ein: facility.details["License/Facility ID#"],
                programTypeOperating: programType,
                programTypePlanning: programType,
                licensed: licensed
            },
            nextStep: 10
        });

        //     await axios.post(`${BACKEND_URL}/bot/bot-step`, {
        //   sessionId,
        //   stepData: {ein: "dfsdsf"},
        // });

        try {
            const res = await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                sessionId,
                stepData: { ein: "dfsdsf" },
            });
            // console.log("res.data", res.data);
            setMessage(res.data.message);
            setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
            setTitle(res.data.title);
            setTotalSteps(res.data.totalSteps);
            setStep(res.data.step);
            setType(res.data.type);
            setOptions(res.data.options || []);
            setCurrentKey(res.data.key);
            setInputValue("");

        } catch (err) {
            console.log("err", err);
            alert(err.response?.data?.error || "Error occurred");
        }

        console.log("Bot API called with EIN");

        const modal = window.bootstrap.Modal.getInstance(FacilityModalRef.current);
        if (modal) modal.hide();

    };

    const handleProviderSelect = async (provider) => {
        // Example: send to backend / chatbot flow
        setStaffProvidersData(null);

        const referral_code = provider.referral_code;

        console.log("referral_code", referral_code);

        await axios.post(`${BACKEND_URL}/bot/bot-session-update`, {
            sessionId,
            data: {
                referral_code: referral_code
            }
        });
    };

    // Handle submit for all types
    const handleSubmit = async (valueOverride = null, micValue = null) => {
        if (!sessionId) return;

        const valueToSend = micValue || valueOverride || inputValue;
        // const modal = window.bootstrap.Modal.getInstance(modalRef.current);
        // if (modal) modal.hide();

        // console.log("valueToSend", valueToSend);

        // Prepare payload
        let stepPayload = {};
        if (type === "multi_input") {
            stepPayload = dynamicMultiInput;   // ✅ important
        } else if (type === "double_password") {
            if (passwordData.password !== passwordData.confirmPassword) {
                alert("Passwords do not match");
                return;
            }
            stepPayload = {
                password: passwordData.password,
                confirmPassword: passwordData.confirmPassword
            };
        } else if (type === "date") {
            const formattedDate = formatToMMDDYYYY(valueToSend);

            if (!isValidDate(formattedDate)) {
                alert("Please enter date in MM/DD/YYYY format");
                return;
            }

            stepPayload = {
                [currentKey]: new Date(valueToSend).toISOString().split("T")[0]
            };
        } else {
            stepPayload = { [currentKey]: valueToSend };
        }

        // Determine what to display in chat
        // const userAnswerText =
        //     type === "multi_input"
        //         ? Object.values(dynamicMultiInput).join(", ")
        //         : type === "double_password"
        //             ? "********"
        //             : Array.isArray(valueToSend)
        //                 ? valueToSend.join(", ")
        //                 : valueToSend;

        const userAnswerText =
            type === "multi_input"
                ? Object.values(dynamicMultiInput).join(", ")
                : type === "double_password"
                    ? "********"
                    : type === "date"
                        ? formatToMMDDYYYY(valueToSend) // 👈 THIS IS THE FIX
                        : Array.isArray(valueToSend)
                            ? valueToSend.join(", ")
                            : valueToSend;

        // setChatHistory(prev => [...prev, { sender: "user", text: userAnswerText }]);
        setChatHistory(prev => [
            ...prev,
            { sender: "user", text: userAnswerText },
            { sender: "bot", loading: true }
        ]);

        // Send to backend
        try {
            const res = await axios.post(`${BACKEND_URL}/bot/bot-step`, {
                sessionId,
                stepData: stepPayload
            });

            const modal = window.bootstrap.Modal.getInstance(modalRef.current);
            if (modal) modal.hide();

            if (res.data.completed) {

                if (res.data.type === "redirect_snapshot_page") {
                    window.location.href = "/readiness-compliance-assistant";
                    return;
                }

                // setCompletedData(res.data);
                setMessage(res.data.message);
                // setChatHistory(prev => prev.filter(msg => !msg.loading));

                // if (res.data.message) {
                //     setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
                // }
                // setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
                setTitle(res.data.title);
                setTotalSteps(res.data.totalSteps);
                const role = res.data.data?.role;
                switch (role) {
                    case "provider":
                        providerRegisterAPI(res.data.data);
                        break;
                    case "worker":
                        workerRegisterAPI(res.data.data);
                        break;
                    case "partner":
                        partnerRegisterAPI(res.data.data);
                        break;
                    case "volunteer":
                        volunteerRegisterAPI(res.data.data);
                        break;
                    default:
                        break;
                }

                return;
            }

            if (res.data.type === "multi_input") {
                if (Array.isArray(res.data.fields)) {
                    const initialState = {};

                    res.data.fields.forEach(field => {
                        initialState[field.value] = "";
                    });

                    setDynamicMultiInput(initialState);
                }
            }
            // console.log("res.data", res.data);
            setMessage(res.data.message);
            // setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
            setChatHistory(prev => prev.filter(msg => !msg.loading));

            if (res.data.message) {
                setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);
            }
            setTitle(res.data.title);
            setTotalSteps(res.data.totalSteps);
            setStep(res.data.step);
            setType(res.data.type);
            setOptions(res.data.options || []);
            setCurrentKey(res.data.key);
            setInputValue("");
            setMultiInputData({ firstName: "", lastName: "" });
            setPasswordData({ password: "", confirmPassword: "" });

            if (res.data.reviewData) {
                setReviewData(res.data.reviewData);
            }

            if (res.data.facilities) {
                setFacilityData(res.data.facilities);
            }

            if (res.data.staffProviders) {
                setStaffProvidersData(res.data.staffProviders);
            }

        } catch (err) {
            console.log("err", err);
            alert(err.response?.data?.error || "Error occurred");
        }
    };

    // Handle file uploads
    const handleFileUpload = async (file) => {
        if (!sessionId || !file) return;

        setChatHistory(prev => [...prev, { sender: "user", text: file.name }]);

        const formData = new FormData();
        formData.append("file", file);
        formData.append("sessionId", sessionId);

        try {
            const res = await axios.post(`${BACKEND_URL}/bot/bot-step`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            setChatHistory(prev => [...prev, { sender: "bot", text: res.data.message }]);

            if (res.data.completed) {
                setCompletedData(res.data);
                setMessage(res.data.message);
                return;
            }

            setMessage(res.data.message);
            setTitle(res.data.title);
            setTotalSteps(res.data.totalSteps);
            setStep(res.data.step);
            setType(res.data.type);
            setOptions(res.data.options || []);
            setCurrentKey(res.data.key);
            setInputValue("");

        } catch (err) {
            alert(err.response?.data?.error || "File upload failed");
        }
    };

    // Determine if next button should show
    const showNextButton = type !== "radio" && type !== "file" && type !== "multi_input" && !completedData && type !== "checkbox" && type !== "double_password" && type !== "dropdown";
    const progressPercent = completedData
        ? 100
        : totalSteps
            ? Math.round(((step - 1) / totalSteps) * 100)
            : 0;

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSubmit();
        }
    };

    const isValidDate = (value) => {
        return /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/.test(value);
    };
    const convertToISO = (date) => {
        const [month, day, year] = date.split("/");
        return `${year}-${month}-${day}`;
    };
    // Render inputs
    const renderInput = () => {

        const handleMicInput = (transcript) => {
            const spoken = transcript.trim().toLowerCase();

            if (type === "radio" || type === "dropdown") {
                const match = options.find(opt =>
                    (opt.label || opt).toLowerCase() === spoken || (opt.value || opt).toLowerCase() === spoken
                );
                if (match) handleSubmit(match.value || match.label || match);
            }
            else if (type === "checkbox") {
                // For simplicity, add spoken option if exists in options
                const matches = options.filter(opt => (opt.label || opt).toLowerCase() === spoken || (opt.value || opt).toLowerCase() === spoken);
                if (matches.length > 0) handleSubmit(matches.map(m => m.value || m.label || m));
            }
            else if (currentKey === "fullName") {
                const parts = spoken.split(" ");
                setMultiInputData({
                    firstName: parts[0] || "",
                    lastName: parts[1] || ""
                });
                handleSubmit(); // submit immediately
            } else if (currentKey === "multi_input_partner") {
                const parts = spoken.split(" ");
                setMultiInputData({
                    fullName: parts[0] || "",
                    organization: parts[1] || "",
                    email: parts[1] || ""
                });
            }
            else {
                setInputValue(transcript);
                handleSubmit(transcript);
            }
        };

        const micButton = (
            <button className="btn btn-secondary ms-2" onClick={startListening}>
                {listening ? "Listening..." : "🎤"}
            </button>
        );

        if (type === "radio") {
            return (
                <div className="d-flex flex-wrap gap-2 p-4">
                    {options.map((opt, index) => {
                        const value = opt.value || opt;
                        const label = opt.label || opt;
                        return (
                            <button key={value || index} onClick={() => handleSubmit(value)}
                                style={{ backgroundColor: "rgb(0, 43, 69)", color: "#fff" }}
                                className="btn btn-sm">{label}</button>
                        );
                    })}
                    {micButton}
                </div>
            );
        }

        if (type === "file") {
            return (
                <div className="card p-3 border-0 shadow-sm rounded-4" style={{ width: "100%" }}>
                    {/* <input
                        type="file"
                        className="form-control mb-2"
                        onChange={(e) => setInputValue(e.target.files[0])}
                        style={{ display: "block", marginBottom: "10px" }}
                        onKeyDown={handleKeyDown}
                    /> */}
                    <input
                        type="file"
                        className="form-control mb-2"
                        // onChange={(e) => {
                        //     const file = e.target.files[0];
                        //     setInputValue(file);          // for immediate upload
                        //     setVerificationFile(file);    // store permanently for final submit
                        // }}
                        onChange={(e) => {
                            const file = e.target.files[0];

                            setInputValue(file); // for immediate upload

                            setFiles((prev) => ({
                                ...prev,
                                [currentKey]: file, // 👈 dynamic key
                            }));
                        }}
                    />
                    {/* {inputValue && <span>Selected file: {inputValue.name}</span>} */}
                    <button
                        className="btn btn-primary mt-2"
                        onClick={() => handleFileUpload(files[currentKey])}
                        disabled={!inputValue}
                    >
                        Upload
                    </button>
                </div>
            );
        }

        if (type === "date") {
            return (
                <div className="d-flex gap-2 align-items-center custom-bot-input-date" style={{ marginRight: "10px" }}>
                    <DatePicker
                        selected={inputValue ? new Date(inputValue) : null}
                        onChange={(date) => {
                            setInputValue(date); // store Date object directly
                        }}
                        dateFormat="MM/dd/yyyy" // 👈 THIS controls display
                        placeholderText="MM/DD/YYYY"
                        className="form-control"
                        maxDate={new Date()}
                    />
                </div>
            );
        }

        if (type === "multi_input") {
            return (
                <div className="d-flex flex-column gap-2 w-100">
                    {Object.keys(dynamicMultiInput).map((fieldKey) => (
                        <input
                            key={fieldKey}
                            type="text"
                            placeholder={fieldKey}
                            value={dynamicMultiInput[fieldKey]}
                            onFocus={() => setActiveMultiField(fieldKey)}
                            onKeyDown={handleKeyDown}
                            onChange={(e) =>
                                setDynamicMultiInput({
                                    ...dynamicMultiInput,
                                    [fieldKey]: e.target.value
                                })
                            }
                            className="form-control"
                        />
                    ))}

                    <div className="d-flex gap-2 mt-2">
                        <button
                            className="btn btn-secondary"
                            onClick={startListening}
                        >
                            {listening ? "Listening..." : "🎤"}
                        </button>

                        <button
                            className="btn btn-primary"
                            onClick={() => handleSubmit()}
                        >
                            Next
                        </button>
                    </div>
                </div>
            );
        }

        if (type === "checkbox") {
            return (
                <div className="d-flex flex-column gap-2">
                    {options.map(opt => {
                        const value = opt.value || opt;
                        const label = opt.label || opt;
                        return (
                            <label key={value} style={{ cursor: "pointer" }}>
                                <input type="checkbox" value={value} checked={checkboxValues.includes(value)}
                                    onChange={e => {
                                        const checked = e.target.checked;
                                        setCheckboxValues(prev => checked ? [...prev, value] : prev.filter(v => v !== value));
                                    }} style={{ marginRight: "8px" }} />
                                {label}
                            </label>
                        );
                    })}
                    <div className="mt-2">{micButton}</div>
                    <button
                        className="btn btn-primary mt-2"
                        onClick={() => handleSubmit(checkboxValues)}
                        onKeyDown={handleKeyDown}
                        disabled={checkboxValues.length === 0}>
                        Next
                    </button>
                </div>
            );
        }

        if (type === "dropdown") {
            return (
                <div className="d-flex align-items-center gap-2" style={{ width: "100%" }}>
                    <select
                        value={inputValue}
                        onChange={(e) => {
                            const value = e.target.value;
                            setInputValue(value);

                            if (value) {
                                handleSubmit(value); // ✅ auto move next
                            }
                        }}
                        className="form-select rounded-pill"
                    >
                        <option value="">Select</option>
                        {options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                    </select>
                    <button className="btn btn-secondary ms-2" onClick={startListening}>
                        {listening ? "Listening..." : "🎤"}
                    </button>
                </div >
            );
        }

        if (currentKey === "fullName") {
            return (
                <div className="d-flex gap-2 align-items-center">
                    <input type="text" placeholder="First Name" value={multiInputData.firstName}
                        onChange={e => setMultiInputData({ ...multiInputData, firstName: e.target.value })} />
                    <input type="text" placeholder="Last Name" value={multiInputData.lastName}
                        onChange={e => setMultiInputData({ ...multiInputData, lastName: e.target.value })} />
                    {micButton}
                </div>
            );
        }

        if (type === "double_password") {
            return (
                <div className="d-flex gap-2 align-items-center" style={{ width: "98%" }}>
                    <input
                        className="form-control"
                        type="password"
                        placeholder="Password"
                        value={passwordData.password}
                        onChange={e => setPasswordData({ ...passwordData, password: e.target.value })}
                        onKeyDown={handleKeyDown}
                    />
                    <input
                        className="form-control"
                        type="password"
                        placeholder="Confirm Password"
                        value={passwordData.confirmPassword}
                        onChange={e => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
                        onKeyDown={handleKeyDown}
                    />
                    <div className="d-flex gap-2 mt-2">
                        <button
                            className="btn btn-primary"
                            onClick={() => handleSubmit()}
                        >
                            Next
                        </button>
                        <button
                            className="btn btn-secondary"
                            onClick={startListening}
                        >
                            {listening ? "Listening..." : "🎤"}
                        </button>
                    </div>
                </div>
            );
        }

        // text input
        return (
            <div className="d-flex gap-2 align-items-center custom-input-wrapper">
                <input type="text" value={inputValue} onChange={e => setInputValue(e.target.value)} placeholder="Enter answer..." className="form-control border-0" onKeyDown={handleKeyDown} />
                {/* {micButton} */}
            </div>
        );
    };

    return (
        <>
            <WorkerHeader />
            <div
                className="modal fade"
                id="addComplianceModal"
                tabIndex="-1"
                ref={modalRef}
                aria-labelledby="addComplianceModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addComplianceModalLabel">
                                Data Overview
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid py-3">
                                <div className="text-center mb-4">
                                    <h3 className="fw-bold text-primary">Data Overview</h3>
                                    <p className="text-muted mb-0">
                                        Please review your answers before submitting
                                    </p>
                                </div>

                                <div className="row g-4">
                                    {reviewData &&
                                        Object.entries(reviewData)
                                            .filter(([key]) => key !== "additionalFacilities")
                                            .map(([key, value]) => {


                                                const formatKey = key
                                                    .replace(/([A-Z])/g, " $1")
                                                    .replace(/^./, str => str.toUpperCase());

                                                return (
                                                    <div className="col-md-6" key={key}>
                                                        <div
                                                            className="p-4 rounded-4 h-100 shadow-sm"
                                                            style={{
                                                                background: "#ffffff",
                                                                border: "1px solid #e9ecef"
                                                            }}
                                                        >
                                                            <div className="text-muted small mb-2">
                                                                {formatKey}
                                                            </div>

                                                            <div
                                                                className="fw-semibold"
                                                                style={{
                                                                    fontSize: "15px",
                                                                    color: "#002B45",
                                                                    wordBreak: "break-word"
                                                                }}
                                                            >
                                                                {value?.toString() || "N/A"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                    {/* Buttons */}
                                    <div className="col-12 mt-4">
                                        <div className="d-flex justify-content-center gap-3">
                                            <button
                                                className="btn btn-primary px-5 py-2 rounded-pill shadow-sm"
                                                // onClick={() => handleSubmit("confirm")}
                                                onClick={() => {
                                                    generateCaptcha();
                                                    setCaptchaInput("");
                                                    setShowCaptchaModal(true);
                                                }}
                                                style={{
                                                    background: "linear-gradient(135deg, #0d6efd, #4dabf7)",
                                                    border: "none",
                                                    fontWeight: "500"
                                                }}
                                            >
                                                Go Ahead
                                            </button>

                                            <button
                                                className="btn btn-primary px-5 py-2 rounded-pill shadow-sm"
                                                onClick={() => handleSubmit("change")}
                                                style={{
                                                    background: "linear-gradient(135deg, #0d6efd, #4dabf7)",
                                                    border: "none",
                                                    fontWeight: "500"
                                                }}
                                            >
                                                Change Anything
                                            </button>
                                        </div>
                                    </div>

                                    {showCaptchaModal && (
                                        <div
                                            className="modal d-block"
                                            tabIndex="-1"
                                            style={{
                                                backgroundColor: "rgba(0,0,0,0.5)"
                                            }}
                                        >
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content border-0 shadow">

                                                    <div className="modal-header">
                                                        <h5 className="modal-title">
                                                            Security Verification
                                                        </h5>

                                                        <button
                                                            type="button"
                                                            className="btn-close"
                                                            onClick={() =>
                                                                setShowCaptchaModal(false)
                                                            }
                                                        ></button>
                                                    </div>

                                                    <div className="modal-body">

                                                        <div className="text-center mb-3">

                                                            <ReCAPTCHA
                                                                ref={recaptchaRef}
                                                                sitekey="6LdAseYsAAAAAHazXJwjk1o0VgWIv-7bd6hl0Bjj"
                                                                onChange={handleCaptchaChange}
                                                            />

                                                        </div>



                                                    </div>

                                                    <div className="modal-footer">

                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            onClick={() =>
                                                                setShowCaptchaModal(false)
                                                            }
                                                        >
                                                            Cancel
                                                        </button>

                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={verifyCaptchaAndSubmit}
                                                        >
                                                            Verify & Submit
                                                        </button>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div
                className="modal fade"
                id="addComplianceModal"
                tabIndex="-1"
                ref={FacilityModalRef}
                aria-labelledby="addComplianceModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addComplianceModalLabel">
                                Claim
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid py-3">
                                <div className="text-center mb-4">
                                    {/* <h3 className="fw-bold text-primary">Facility</h3> */}
                                    <p className="text-muted mb-0">
                                        Please Claim your facility (you can select multiple)
                                    </p>
                                </div>

                                <div className="row g-4">

                                    {facilityData?.map((facility, index) => (
                                        <div className="col-md-6" key={index}>
                                            <div className="card shadow-sm h-100 border-0">
                                                <div className="card-body">

                                                    <h5 className="card-title text-primary fw-bold">
                                                        <input
                                                            type="checkbox"
                                                            className="me-3"
                                                            checked={selectedFacilities.includes(facility)}
                                                            onChange={() => handleFacilitySelect(facility)}
                                                            style={{ transform: "scale(1.5)", cursor: "pointer" }}
                                                        />
                                                        {facility.facilityName}
                                                    </h5>

                                                    <p className="mb-2">
                                                        <strong>Address:</strong><br />
                                                        {facility.street}, {facility.city}, {facility.state} {facility.zip}
                                                    </p>

                                                    <p className="mb-2">
                                                        <strong>Phone:</strong> {facility.phone}
                                                    </p>

                                                    {facility.details &&
                                                        Object.entries(facility.details).map(([key, value], i) => (
                                                            <p className="mb-2" key={i}>
                                                                <strong>{cleanText(key)}:</strong> {cleanText(value)}
                                                            </p>
                                                        ))
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="text-center mt-4">
                                        <button
                                            className="btn btn-success px-4"
                                            disabled={selectedFacilities.length === 0}
                                            onClick={handleMultipleClaim}
                                        >
                                            Claim Selected ({selectedFacilities.length})
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="modal fade"
                id="addComplianceModal"
                tabIndex="-1"
                ref={StaffProvidersModalRef}
                aria-labelledby="addComplianceModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addComplianceModalLabel">
                                Providers List
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid py-3">
                                <div className="text-center mb-4">
                                    {/* <h3 className="fw-bold text-primary">Facility</h3> */}
                                    <p className="text-muted mb-0">
                                        Please Select Provider
                                    </p>
                                </div>

                                <div className="row g-4">

                                    {staffProvidersData?.map((providers, index) => (
                                        <div className="col-md-6" key={index}>
                                            <div className="card shadow-sm h-100 border-0">
                                                <div className="card-body">

                                                    <h5 className="card-title text-primary fw-bold">

                                                        <input
                                                            className="form-check-input me-3"
                                                            type="radio"   // use checkbox if multiple select needed
                                                            name="providerSelect"
                                                            checked={selectedStaffProvider?.id === providers.id}
                                                            onChange={() => setSelectedStaffProvider(providers)}
                                                        />


                                                        {providers.business_name}
                                                    </h5>

                                                    <p className="mb-2">
                                                        <strong>Name:</strong> {providers.first_name} {providers.last_name}
                                                    </p>

                                                    <p className="mb-2">
                                                        <strong>Phone:</strong> {providers.phone || "N/A"}
                                                    </p>

                                                    <p className="mb-2">
                                                        <strong>Email:</strong> {providers.email || "N/A"}
                                                    </p>

                                                    <p className="mb-2">
                                                        <strong>Referral Code:</strong> {providers.referral_code || "N/A"}
                                                    </p>
                                                    <p className="mb-2">
                                                        <strong>Operation Status:</strong> {providers.operation_status || "N/A"}
                                                    </p>
                                                    <p className="mb-2">
                                                        <strong>Staff Count:</strong> {providers.staff_count || "N/A"}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="text-center mt-4">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            disabled={!selectedStaffProvider}
                                            onClick={() => {
                                                console.log("Selected Provider:", selectedStaffProvider);

                                                // 👉 send to next flow / API / parent
                                                handleProviderSelect(selectedStaffProvider);

                                                // close modal (bootstrap way)
                                                const modalEl = StaffProvidersModalRef.current;
                                                const modal = window.bootstrap.Modal.getInstance(modalEl);
                                                modal.hide();
                                            }}
                                        >
                                            Select Provider
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mb-4">
                <div className="container-sm">
                    <div className="card shadow mt-4 mx-auto chat-wrapper">
                        <div className="header d-flex align-items-center px-3" style={{ backgroundColor: "rgb(0, 43, 69)", minHeight: "70px" }}>
                            <div className="profile me-3">
                                <img
                                    src="/assets/images/profile_rounded_2.jpg"
                                    alt="profile-avatar"
                                    className="rounded-circle"
                                    style={{ height: "55px", width: "55px", objectFit: "cover" }}
                                />
                            </div>

                            <div className="d-flex justify-content-between align-items-center w-100 flex-wrap">
                                <div style={{ color: "#fff" }}>
                                    <h4 className="mb-0">Nia</h4>
                                    <small>NCAF Onboarding Assistant</small>
                                </div>
                            </div>
                        </div>

                        <div className="p-2">
                            {/* profile card */}
                            <div className="card mt-3 p-3" style={{ borderRadius: "10px" }}>
                                <div className="row align-items-stretch">

                                    {/* LEFT IMAGE */}
                                    <div className="col-md-3 d-flex align-items-center">
                                        <img
                                            className="rounded-circle img-fluid"
                                            src="/assets/images/profile_rounded_2.jpg"
                                            alt="profile"
                                            style={{ maxHeight: "220px", objectFit: "cover" }}
                                        />
                                    </div>

                                    {/* RIGHT OPTIONS */}
                                    <div className="col-md-9 d-flex align-items-center justify-content-center">
                                        <div style={{ width: "100%", maxWidth: "500px" }}>

                                            {/* Option 1 */}
                                            <div className="d-flex justify-content-between align-items-center border p-3 rounded mb-2">
                                                <div>
                                                    <p className="mb-0 fw-bold" style={{ color: "rgb(0, 43, 69)" }}>
                                                        Start Readiness Snapshot
                                                    </p>
                                                    <small>Check compliance deadlines</small>
                                                </div>
                                                <button
                                                    className="btn btn-sm"
                                                    onClick={() => navigate("/readiness-compliance-assistant")}
                                                    style={{ backgroundColor: "rgb(0, 43, 69)", color: "#fff" }}
                                                >
                                                    Start
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* legal advice card */}
                            <div className="card mt-3 shadow-sm border-0" style={{ borderRadius: "12px" }}>
                                <div
                                    className="d-flex align-items-start p-3"
                                    style={{
                                        backgroundColor: "#e9ecf5",
                                        borderRadius: "12px"
                                    }}
                                >

                                    {/* Icon Section */}
                                    <div
                                        className="me-3 d-flex justify-content-center align-items-center"
                                        style={{
                                            minWidth: "40px",
                                            color: "#fff",
                                            borderRadius: "50%",
                                            fontSize: "18px"
                                        }}
                                    >
                                        ℹ️
                                    </div>

                                    {/* Text Section */}
                                    <div>
                                        <p className="mb-1 small">
                                            NCAF provides reminders and coordination support.
                                        </p>
                                        <p className="mb-0 small text-muted">
                                            We are not a licensing authority and do not provide legal advice.
                                        </p>
                                    </div>

                                </div>
                            </div>
                            {/* chat */}

                            <div
                                ref={chatContainerRef}
                                className="chat-body"
                            >
                                {chatHistory.map((msg, index) => (
                                    <div key={index}>

                                        {/* ✅ USER MESSAGE */}
                                        {msg.sender === "user" && (
                                            <div
                                                className="card mt-2 border-1 p-2"
                                                style={{
                                                    backgroundColor: "rgb(220,240,250)",
                                                    marginLeft: "20%",
                                                    borderRadius: "10px"
                                                }}
                                            >
                                                <p className="mb-0">{msg.text}</p>
                                            </div>
                                        )}

                                        {/* ✅ BOT MESSAGE */}
                                        {msg.sender === "bot" && (
                                            <div className="card p-2 mt-3" style={{ borderRadius: "10px" }}>
                                                <div
                                                    className="card p-2 m-0"
                                                    style={{
                                                        backgroundColor: "#cbccd8",
                                                        borderRadius: "10px"
                                                    }}
                                                >
                                                    {msg.loading ? (
                                                        <div className="d-flex align-items-center">
                                                            <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                                                            <span>Typing...</span>
                                                        </div>
                                                    ) : (
                                                        <p className="mb-0">{msg.text}</p>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                ))}
                            </div>


                            {/* type message */}
                            <div className="chat-input-container p-2 border-2">
                                <div className="input-group chat-input shadow-sm">

                                    {/* Send Button */}
                                    {!completedData && !isReviewStep && renderInput()}

                                    {showNextButton && (
                                        <>
                                            <button
                                                className="btn bg-white border-0"
                                                onClick={() => handleSubmit()}
                                                onKeyDown={handleKeyDown}
                                                disabled={!inputValue && type === "text"}
                                            >
                                                <i className="bi bi-send me-2"></i>
                                            </button>
                                            <button className="btn btn-secondary ms-2" onClick={startListening}>
                                                {listening ? "Listening..." : "🎤"}
                                            </button>
                                        </>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                    {loading && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                background: "rgba(0,0,0,0.4)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 9999
                            }}
                        >
                            <div className="spinner-border text-light" style={{ width: "3rem", height: "3rem" }} />
                        </div>
                    )}


                    {onboardingStatus && (
                        <div className="text-center py-5">

                            {onboardingStatus === "success" && (
                                <>
                                    <div style={{ fontSize: "60px" }}>🎉</div>
                                    <h3 className="text-success mt-3">
                                        Onboarding Completed Successfully!
                                    </h3>
                                    <p className="text-muted">
                                        Thank you for registering with us.
                                    </p>
                                </>
                            )}

                            {onboardingStatus === "failed" && (
                                <>
                                    <div style={{ fontSize: "60px" }}>❌</div>
                                    <h3 className="text-danger mt-3">
                                        Onboarding Failed
                                    </h3>
                                    <p className="text-muted">
                                        Something went wrong. Please try again.
                                    </p>

                                    <button
                                        className="btn btn-primary mt-3"
                                        onClick={() => setOnboardingStatus(null)}
                                    >
                                        Try Again
                                    </button>
                                </>
                            )}

                        </div>
                    )}
                </div>
            </div>

            <WorkerFooter />
        </>
    );
};

export default WorkerBotChat;